"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const messages_1 = __importDefault(require("@powerednow/shared/constants/messages"));
const bluebird_1 = __importDefault(require("bluebird"));
const customerEmailTemplateValues_1 = require("@powerednow/shared/constants/customerEmailTemplateValues");
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const modelLookup_1 = require("../modelLookup");
const entity_1 = __importDefault(require("./entity"));
const modelProperties_1 = __importDefault(require("./modelProperties"));
// eslint-disable-next-line no-redeclare
class ContactMethod extends complexData_1.default {
    static get allowedAssociations() {
        return {
            contactMethodType: {
                key: 'contactMethodType',
                instance: (0, modelLookup_1.complexFindModel)('ContactMethodType'),
                single: true,
                condition: {
                    id: this.Entity.getFieldSymbols().contactmethodtype_id,
                },
            },
            contact: {
                key: 'contact',
                instance: (0, modelLookup_1.complexFindModel)('Contact'),
                single: true,
                condition: {
                    id: this.Entity.getForeignFieldSymbols().contact_id,
                },
            },
        };
    }
    get fieldChangeEventHandlers() {
        return {
            value: () => {
                this.data.is_valid = false;
            },
        };
    }
    static get singularName() {
        return 'ContactMethod';
    }
    /* eslint class-methods-use-this: "off" */
    canReceiveSMS() {
        return false;
    }
    isWhatsApp() {
        return this.data.contactmethodtype_id === messages_1.default.TYPES.WHATSAPP;
    }
    async canReceiveDoc() {
        return Boolean(await this.getContactMethodTypeProperty('canreceivedoc'));
    }
    async isRegular() {
        return Boolean(await this.getContactMethodTypeProperty('is_regular'));
    }
    async isAdditional() {
        return Boolean(await this.getContactMethodTypeProperty('is_additional'));
    }
    async canText() {
        return Boolean(await this.getContactMethodTypeProperty('can_text'));
    }
    async canEmail() {
        return Boolean(await this.getContactMethodTypeProperty('can_email'));
    }
    async canCall() {
        return Boolean(await this.getContactMethodTypeProperty('can_call'));
    }
    hasValue() {
        return (this.data.value || '').trim() !== '';
    }
    async hasChannel(channel) {
        const canText = await this.canText();
        const canCall = await this.canCall();
        const canEmail = await this.canEmail();
        return (channel === 'SMS' && canText)
            || (channel === 'CALL' && canCall)
            || (channel === 'EMAIL' && canEmail);
    }
    async isContactable(channels) {
        const isContactable = await bluebird_1.default.reduce(channels, async (contactable, channel) => {
            const hasChannel = await this.hasChannel(channel);
            return contactable || hasChannel;
        }, false);
        return this.hasValue() && isContactable;
    }
    async findContactMethodType() {
        return this.getContactMethodType();
    }
    async getContactMethodTypeProperty(property) {
        const methodType = await this.findContactMethodType();
        if (methodType && methodType.data) {
            return methodType.data[property];
        }
        const error = new Error('cannot find contactMethod');
        throw Object.assign(error, {
            details: {
                contactMethod: this.dataValues,
                contactMethodTypeProperty: property,
            },
        });
    }
    async getSearchableFields() {
        return [this.data.value];
    }
    getPropertiesToCopy() {
        const { value } = this.data.getPureDataValues();
        return { value };
    }
    async copyData(item) {
        Object.assign(this.data, item.getPropertiesToCopy());
        return this;
    }
    async getTemplateData() {
        const data = { ...this.data.getPureDataValues() };
        const contactMethodType = await this.getContactMethodType();
        data.name = contactMethodType.data.name;
        return data;
    }
    getChannelType() {
        return customerEmailTemplateValues_1.ContactMethodTypeMap[this.data.contactmethodtype_id];
    }
    getChannelTypeId() {
        return customerEmailTemplateValues_1.ChannelTypeDetails[this.getChannelType()].ID;
    }
}
ContactMethod.Entity = entity_1.default;
ContactMethod.modelProperties = modelProperties_1.default;
exports.default = ContactMethod;
//# sourceMappingURL=../../../../src/models/contactMethod/index.js.map